import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1OrganizationRecordsList: build.query<
      ApiAdminV1OrganizationRecordsListApiResponse,
      ApiAdminV1OrganizationRecordsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          organization_id: queryArg.organizationId,
          search: queryArg.search,
        },
      }),
    }),
    apiAdminV1OrganizationRecordsCreate: build.mutation<
      ApiAdminV1OrganizationRecordsCreateApiResponse,
      ApiAdminV1OrganizationRecordsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/`,
        method: "POST",
        body: queryArg.organizationRecordCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordsRetrieve: build.query<
      ApiAdminV1OrganizationRecordsRetrieveApiResponse,
      ApiAdminV1OrganizationRecordsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/${queryArg.id}/`,
      }),
    }),
    apiAdminV1OrganizationRecordsUpdate: build.mutation<
      ApiAdminV1OrganizationRecordsUpdateApiResponse,
      ApiAdminV1OrganizationRecordsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.organizationRecordCreateUpdate,
      }),
    }),
    apiAdminV1OrganizationRecordsDestroy: build.mutation<
      ApiAdminV1OrganizationRecordsDestroyApiResponse,
      ApiAdminV1OrganizationRecordsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/organization-records/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1OrganizationRecordsListApiResponse =
  /** status 200  */ OrganizationRecordRead[];
export type ApiAdminV1OrganizationRecordsListApiArg = {
  /** ID of the assessment period */
  assessmentPeriodId?: number;
  /** ID of the organization */
  organizationId?: number;
  /** Search term for value */
  search?: string;
};
export type ApiAdminV1OrganizationRecordsCreateApiResponse =
  /** status 201  */ OrganizationRecordRead;
export type ApiAdminV1OrganizationRecordsCreateApiArg = {
  organizationRecordCreateUpdate: OrganizationRecordCreateUpdate;
};
export type ApiAdminV1OrganizationRecordsRetrieveApiResponse =
  /** status 200  */ OrganizationRecordRead;
export type ApiAdminV1OrganizationRecordsRetrieveApiArg = {
  /** A unique integer value identifying this organization record. */
  id: number;
};
export type ApiAdminV1OrganizationRecordsUpdateApiResponse =
  /** status 200  */ OrganizationRecordRead;
export type ApiAdminV1OrganizationRecordsUpdateApiArg = {
  /** A unique integer value identifying this organization record. */
  id: number;
  organizationRecordCreateUpdate: OrganizationRecordCreateUpdate;
};
export type ApiAdminV1OrganizationRecordsDestroyApiResponse = unknown;
export type ApiAdminV1OrganizationRecordsDestroyApiArg = {
  /** A unique integer value identifying this organization record. */
  id: number;
};
export type OrganizationRecord = {
  value: string;
};
export type OrganizationRecordRead = {
  id: number;
  organization: string;
  organization_record_value: string;
  value: string;
  assessment_period: string;
  created_at: string;
  updated_at: string;
};
export type OrganizationRecordCreateUpdate = {
  id?: number;
  organization: number;
  organization_record_value: number;
  value?: string;
  assessment_period?: number | null;
};
export const {
  useApiAdminV1OrganizationRecordsListQuery,
  useApiAdminV1OrganizationRecordsCreateMutation,
  useApiAdminV1OrganizationRecordsRetrieveQuery,
  useApiAdminV1OrganizationRecordsUpdateMutation,
  useApiAdminV1OrganizationRecordsDestroyMutation,
} = injectedRtkApi;
